import { InstabilityMessagesConfiguration } from '../interfaces/InstabilityMessagesConfiguration';

export default class InstabilityMessagesConfig {
  private static config: InstabilityMessagesConfiguration = {
    keepAuthenticated: process.env.REACT_APP_INSTABILITY_MESSAGES_KEEP_AUTHENTICATED === 'true',
    keepNotAuthenticated: process.env.REACT_APP_INSTABILITY_MESSAGES_KEEP_NOT_AUTHENTICATED === 'true',
  };

  public static Current(): InstabilityMessagesConfiguration { return InstabilityMessagesConfig.config; }
}
